import { render } from "./FlowDeletePage.vue?vue&type=template&id=2fb23338"
import script from "./FlowDeletePage.vue?vue&type=script&lang=js"
export * from "./FlowDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__